module.exports = __webpack_public_path__ + "img/g-8.9697d8df.svg";